<template>
    <div id="support-page" class="main-page">
        <vue-headful title="Support | Gunspring"/>
        <div class="gs-breadcrumbs">
            <div class="container">
                <span><a href="#" class="gs-breadcrumb">home</a></span>
                <span><i class="fas fa-chevron-right gs-breadcrumb-arrow"></i></span>
                <span class="gs-breadcrumb-active">support</span>
            </div>
        </div>
        <div class="container">

            <div class="page-hero">
                <p class="page-hero-title">Support Resource Center</p>
                <p class="page-hero-text">Welcome to the Gunspring Resource Center. You'll find comprehensive guides and documentation to help you start working with Gunspring Protect as quickly as possible, as well as support if you get stuck. Let's jump right in!</p>
            </div>
            
            <div class="support-guides-documentation">
                <p class="support-mini-title">users</p>
                <p class="support-section-title">Guides and documentation</p>
                <p class="support-section-text">Select the documentation version specific to your ecommerce platform</p>
                <div class="support-guides-documentation-cols">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 support-guides-documentation-col">
                            <div class="guides-docs-placeholder"></div>
                            <p class="guides-docs-version-number">v1.0</p>
                            <p class="guides-docs-version-text">For Magento*, PrestaShop, WooCommerce, and thirty bees users</p>
                            <p class="guides-docs-version-note">*Gunspring installs prior to March 2020</p>
                            <a href="#" class="guides-docs-version-link">View v1.0 documentation</a>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 support-guides-documentation-col">
                            <div class="guides-docs-placeholder"></div>
                            <p class="guides-docs-version-number">v1.0</p>
                            <p class="guides-docs-version-text">For Magento*, PrestaShop, WooCommerce, and thirty bees users</p>
                            <p class="guides-docs-version-note">*Gunspring installs prior to March 2020</p>
                            <a href="#" class="guides-docs-version-link">View v1.0 documentation</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="support-developers">
            <div class="container text-center">
                <p class="support-mini-title">developers</p>
                <p class="support-section-title">Guides and documentation</p>
                <p class="support-section-text dark-grey">Select the documentation version specific to your ecommerce platform</p>
                <a href="#" class="blue-cta developer-portal-btn text-center">Developer portal <i class="fas fa-external-link-alt"></i></a>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    
}
</script>